import React, { useEffect } from 'react';

import { useStudentDispatch } from '../../../../hooks/useStudentDispatch';
import { Guid } from '../../../../store/model/guid';
import { addCompletedItem } from '../../../../store/reducers/student/tracking/itemsTrackingActions';

type ItemViewedProps = {
  itemId: Guid;
  isCompleted: boolean;
};

export const ItemViewed: React.FC<ItemViewedProps> = ({ itemId, isCompleted }) => {
  const dispatch = useStudentDispatch();
  useEffect(() => {
    if (isCompleted) {
      dispatch(addCompletedItem(itemId));
    }
  }, [itemId, isCompleted, dispatch]);
  return null;
};
